export const GET_CHANCE_GAMES_RULES_REQUEST = 'GET_CHANCE_GAMES_RULES_REQUEST';
export const GET_CHANCE_GAMES_RULES_SUCCESS = 'GET_CHANCE_GAMES_RULES_SUCCESS';
export const GET_CHANCE_GAMES_RULES_FAILURE = 'GET_CHANCE_GAMES_RULES_FAILURE';

export const GET_CHANCE_GAMES_LIST_REQUEST = 'GET_CHANCE_GAMES_LIST_REQUEST';
export const GET_CHANCE_GAMES_LIST_SUCCESS = 'GET_CHANCE_GAMES_LIST_SUCCESS';
export const GET_CHANCE_GAMES_LIST_FAILURE = 'GET_CHANCE_GAMES_LIST_FAILURE';

export const GET_CHANCE_GAMES_COUPONS_REQUEST = 'GET_CHANCE_GAMES_COUPONS_REQUEST';
export const GET_CHANCE_GAMES_COUPONS_SUCCESS = 'GET_CHANCE_GAMES_COUPONS_SUCCESS';
export const GET_CHANCE_GAMES_COUPONS_FAILURE = 'GET_CHANCE_GAMES_COUPONS_FAILURE';

export const PLAY_CHANCE_GAMES_COUPON_REQUEST = 'PLAY_CHANCE_GAMES_COUPON_REQUEST';
export const PLAY_CHANCE_GAMES_COUPON_SUCCESS = 'PLAY_CHANCE_GAMES_COUPON_SUCCESS';
export const PLAY_CHANCE_GAMES_COUPON_FAILURE = 'PLAY_CHANCE_GAMES_COUPON_FAILURE';

export const GET_CHANCE_GAMES_ACTIVE_DRAW_REQUEST = 'GET_CHANCE_GAMES_ACTIVE_DRAW_REQUEST';
export const GET_CHANCE_GAMES_ACTIVE_DRAW_SUCCESS = 'GET_CHANCE_GAMES_ACTIVE_DRAW_SUCCESS';
export const GET_CHANCE_GAMES_ACTIVE_DRAW_FAILURE = 'GET_CHANCE_GAMES_ACTIVE_DRAW_FAILURE';

export const GET_CHANCE_GAMES_DRAW_LIST_REQUEST = 'GET_CHANCE_GAMES_DRAW_LIST_REQUEST';
export const GET_CHANCE_GAMES_DRAW_LIST_SUCCESS = 'GET_CHANCE_GAMES_DRAW_LIST_SUCCESS';
export const GET_CHANCE_GAMES_DRAW_LIST_FAILURE = 'GET_CHANCE_GAMES_DRAW_LIST_FAILURE';

export const GET_CHANCE_GAMES_DRAW_PRIZE_REQUEST = 'GET_CHANCE_GAMES_DRAW_PRIZE_REQUEST';
export const GET_CHANCE_GAMES_DRAW_PRIZE_SUCCESS = 'GET_CHANCE_GAMES_DRAW_PRIZE_SUCCESS';
export const GET_CHANCE_GAMES_DRAW_PRIZE_FAILURE = 'GET_CHANCE_GAMES_DRAW_PRIZE_FAILURE';

export const GET_DRAWS_REQUEST = 'GET_DRAWS_REQUEST';
export const GET_DRAWS_SUCCESS = 'GET_DRAWS_SUCCESS';
export const GET_DRAWS_FAILURE = 'GET_DRAWS_FAILURE';

export const GET_DRAWS_BY_ID_REQUEST = 'GET_DRAWS_BY_ID_REQUEST';
export const GET_DRAWS_BY_ID_SUCCESS = 'GET_DRAWS_BY_ID_SUCCESS';
export const GET_DRAWS_BY_ID_FAILURE = 'GET_DRAWS_BY_ID_FAILURE';

export const RAFFLE_BUY_TICKET_REQUEST = 'RAFFLE_BUY_TICKET_REQUEST';
export const RAFFLE_BUY_TICKET_SUCCESS = 'RAFFLE_BUY_TICKET_SUCCESS';
export const RAFFLE_BUY_TICKET_FAILURE = 'RAFFLE_BUY_TICKET_FAILURE';

export const GET_TICKET_COUNT_REQUEST = 'GET_TICKET_COUNT_REQUEST';
export const GET_TICKET_COUNT_SUCCESS = 'GET_TICKET_COUNT_SUCCESS';
export const GET_TICKET_COUNT_FAILURE = 'GET_TICKET_COUNT_FAILURE';

export const GENERATE_CG_COUPONS_REQUEST = 'GENERATE_CG_COUPONS_REQUEST';
export const GENERATE_CG_COUPONS_SUCCESS = 'GENERATE_CG_COUPONS_SUCCESS';
export const GENERATE_CG_COUPONS_FAILURE = 'GENERATE_CG_COUPONS_FAILURE';

export const SET_CG_GENERATED_COLUMNS_TO_SLIP = 'SET_CG_GENERATED_COLUMNS_TO_SLIP';
export const TOGGLE_CG_NUMBER = 'TOGGLE_CG_NUMBER';
export const TOGGLE_CG_EXTRA_NUMBER = 'TOGGLE_CG_EXTRA_NUMBER';
export const SET_CG_ACTIVE_COLUMN = 'SET_CG_ACTIVE_COLUMN';
export const CLEAR_CG_COLUMN = 'CLEAR_CG_COLUMN';
export const TOGGLE_CG_SLIP = 'TOGGLE_CG_SLIP';
export const CLEAR_CG_SLIP = 'CLEAR_CG_SLIP';
export const SET_AUTO_CG_SELECTIONS = 'SET_AUTO_CG_SELECTIONS';
export const SET_CHANGE_GAMES_DEFAULT_COLUMNS = 'SET_CHANGE_GAMES_DEFAULT_COLUMNS';
export const SET_CHANCE_GAMES_PLAY_DATA_FROM_LOCAL_STORAGE = 'SET_CHANCE_GAMES_PLAY_DATA_FROM_LOCAL_STORAGE';
